import React from "react";
import { useState, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';

import SearchBar from "./common/SearchBar";

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';



export default function FormEditParams({formData, setFormData}){

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();

  const [formErrors, setFormErrors] = useState({})
  //const [formSection, setFormSection] = useState("")
  //const [formLiterals, setFormLiterals] = useState("")

  
  const handleChange = (event) => {

    let newFormData = structuredClone(formData);
    
    if (event.target.id === 'samples_letters') {
      if (event.target.value === "") {
        newFormData[event.target.id] = []
      } else {
        newFormData[event.target.id] = event.target.value.split(",")
      }
    } else {
      newFormData[event.target.id] = event.target.value;
    }

    setFormData(newFormData)
  };

  
  function saveForm () {

    //alert('!!!')

    let params = {
      section: formData.section || "",
      samples_letters: formData.samples_letters || [],
      form_view_mode: formData.form_view_mode,
    };

    //console.log(params)

    axios_api.put(api_url + `/manage_form/` + formData.id, params, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        console.log("Form params saved");
        navigate(0)
        //setIsDirty(false);
        // Очищаем ошибки валидации после успешного сохранения
        //setValidationErrors({
        //  schema: { errors: [], warnings: [] },
        //  uiSchema: { errors: [], warnings: [] }
        //});
        //setHasValidationErrors(false);
      },
      (error) => {
        console.log(error);
        setFormErrors(error.response?.data)
      }
    );
  }
  

  return (
    <>
      <div className="row">
        <h3 className="m-3">Параметры формы</h3>
      </div>
      <div className='m-3'>
        <div className="lk-form">
          <form>
            <div className="input-group mt-3 mb-2">
              <label className="">
                <p>введите значение section</p> 
                <input id="section" type="text" className="form-control"  value={formData['section'] ? formData['section'] : ""} onChange={handleChange}></input>
              </label>
            </div>
            { formErrors?.section &&
              <p className="text-danger">{formErrors["section"]}</p>
            }
            <div className="input-group mt-3 mb-2">
              <label className="">
                <p>введите литералы образцов через запятую</p> 
                <input id="samples_letters" type="text" className="form-control"  value={formData['samples_letters'] ? formData['samples_letters'].toString() : ""} onChange={handleChange}></input>
              </label>
            </div>
            { formErrors?.samples_letters &&
              <p className="text-danger">{formErrors["samples_letters"][0]}</p>
            }
            <div className="input-group mt-3 mb-2">
              <label className="">
                <p>режим отображения формы</p> 
                <select id="form_view_mode" type="select" className="lk-select form-select"  value={formData['form_view_mode'] ? formData['form_view_mode'] : ""} onChange={handleChange}>
                  <option value="SCREEN_FIT">Вписывать в экран по ширине</option>
                  <option value="HORIZONTAL_SCROLL">Горизонтальная прокрутка при ширине больше экрана</option>
                </select>
              </label>
            </div>
            { formErrors?.section &&
              <p className="text-danger">{formErrors["form_veiw_mode"]}</p>
            }            
            <button type="button" onClick={saveForm} className="btn lk-button my-3">Сохранить параметры</button>
          </form>
        </div>               
      </div> 
    </>
  )
}